import { datadogLogs } from '@datadog/browser-logs';
import * as qs from 'qs';
import { removeDuplicate } from '../remove-duplicate';
export var retrieveGCLID = function (accountOrigin) {
    var _a, _b;
    try {
        if (location === null || location === void 0 ? void 0 : location.search) {
            var queryString = qs.parse(location === null || location === void 0 ? void 0 : location.search, { ignoreQueryPrefix: true });
            return ((_a = removeDuplicate(queryString.gclid)) === null || _a === void 0 ? void 0 : _a.toString()) || null;
        }
        else if (accountOrigin) {
            var queryString = qs.parse(new URL(accountOrigin).search, { ignoreQueryPrefix: true });
            return ((_b = removeDuplicate(queryString.gclid)) === null || _b === void 0 ? void 0 : _b.toString()) || null;
        }
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred while attempting to retrieve GclId.", { error: error }, error);
    }
    return null;
};
//# sourceMappingURL=index.js.map